import EventBus from "@plugins/common/service/eventbus";

const drawingEventBus = new EventBus();
export default drawingEventBus;
